import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { roleService } from '@/services/role-service';
import type { Role } from '@/types/core/role';
import type { UUID } from '@/utils/uuid';

import { roleQueryKeys } from './query-keys';

/**
 * Find a specific role by ID.
 * Returns a react-query query.
 */
export function useFindRole(
  tenantId?: UUID,
  roleId?: UUID
): UseQueryResult<Role | null, Error> {
  return useQuery<Role | null, Error>({
    queryKey: roleQueryKeys.detail(tenantId, roleId),
    queryFn: async () => {
      if (!tenantId || !roleId) return null;
      return roleService.findRole(tenantId, roleId);
    },
    enabled: !!tenantId && !!roleId,
  });
}
